import { render } from "./fab_products.vue?vue&type=template&id=6b7efa0c"
import script from "./fab_products.vue?vue&type=script&lang=js"
export * from "./fab_products.vue?vue&type=script&lang=js"
script.render = render

export default script